import React, { useState, useEffect, useCallback, ReactElement } from "react";
import { DotButton, PrevButton, NextButton } from "./EmblaCarouselButtons";
import useEmblaCarousel from "embla-carousel-react";
import { mediaByIndex } from "./media";
import { MediaAndText } from "../MediaAndText/MediaAndText";

type Carousel = {
  slides: Array<ReactElement>;
  className?: string;
};
export const Carousel: React.FC<Carousel> = ({
  slides,
  className = "bg-coinage-offWhite"
}) => {
  const [viewportRef, embla] = useEmblaCarousel({ skipSnaps: false, align: 0 });
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const scrollPrev = useCallback(() => embla && embla.scrollPrev(), [embla]);
  const scrollNext = useCallback(() => embla && embla.scrollNext(), [embla]);
  const scrollTo = useCallback(
    (index: number) => embla && embla.scrollTo(index),
    [embla]
  );

  const onSelect = useCallback(() => {
    if (!embla) return;
    setSelectedIndex(embla.selectedScrollSnap());
    setPrevBtnEnabled(embla.canScrollPrev());
    setNextBtnEnabled(embla.canScrollNext());
  }, [embla, setSelectedIndex]);

  useEffect(() => {
    if (!embla) return;
    onSelect();
    setScrollSnaps(embla.scrollSnapList());
    embla.on("select", onSelect);
  }, [embla, setScrollSnaps, onSelect]);

  return (
    <>
      <div className={`embla ${className}`}>
        <div className="embla__viewport" ref={viewportRef}>
          <div className="embla__container">
            {slides.map((slide, index) => (
              <div className="embla__slide" key={index}>
                <div className="embla__slide__inner">
                  <div className="h-full w-full lrg:mt-auto">{slide}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {slides.length > 1 && (
        <div className="embla__dots mt-4">
          <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              selected={index === selectedIndex}
              onClick={() => scrollTo(index)}
            />
          ))}
          <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
        </div>
      )}
    </>
  );
};
